import { render, staticRenderFns } from "./ChatsMobile.vue?vue&type=template&id=72328520&scoped=true&"
import script from "./ChatsMobile.vue?vue&type=script&lang=js&"
export * from "./ChatsMobile.vue?vue&type=script&lang=js&"
import style0 from "./ChatsMobile.vue?vue&type=style&index=0&id=72328520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72328520",
  null
  
)

export default component.exports